export default __webpack_public_path__ + "static/media/1.23b85786.jpg";